<template>
  <FormationDetailLayout
    lesson="Formation VTC Continue"
    back-item="formation-vtc"
    :hero-image="heroImage"
    hero-alt="road-with-circle-speed-effect"
    hero-eyebrow="Renouvellement carte VTC"
    hero-title="VTC CONTINUE"
    :hero-stats="heroStats"
  >
    <template #main>
      <article class="formation-section formation-section--intro">
        <h2>Formation VTC continue</h2>

        <div class="formation-flow">
          <p>
            La
            <strong>formation continue pour les chauffeurs VTC</strong>
            (Véhicules de Tourisme avec Chauffeur) est une étape cruciale pour
            maintenir ses compétences et rester à jour dans le domaine du
            transport de personnes. Elle est obligatoire pour tous les
            chauffeurs
            <strong>VTC titulaires d'une carte professionnelle</strong>. La
            durée de la formation, fixée par la réglementation, est de 14 heures
            renouvelables tous les cinq ans.
          </p>

          <p>
            Cette <strong>formation continue</strong> offre de nombreux
            avantages. Elle permet aux <strong>chauffeurs VTC</strong> de se
            tenir informés des dernières réglementations et des évolutions dans
            le secteur. En suivant régulièrement des
            <strong>formations</strong>, les chauffeurs peuvent actualiser leurs
            connaissances en matière de réglementation spécifique aux
            <strong>VTC</strong>, de sécurité routière, de gestion, ainsi que
            d'autres aspects importants de leur activité.
          </p>
        </div>
      </article>

      <article class="formation-section formation-section--theory">
        <h2>Renouvellement carte professionnelle VTC</h2>

        <div class="formation-panel">
          <h3>4 MODULES</h3>

          <ul class="formation-list">
            <li>A – Droit du transport public particuliers de personnes</li>
            <li>B – Réglementation spécifique lié à l’activité de VTC</li>
            <li>C – Sécurité Routière</li>
            <li>D – Anglais</li>
          </ul>

          <div class="formation-panel__footer">
            <p>3h30 par module</p>
          </div>
        </div>
      </article>

      <article class="formation-section formation-section--t3p">
        <h2>
          Faire une demande de renouvellement de sa carte professionnelle de vtc
        </h2>

        <div class="formation-flow">
          <p>
            Pour <strong>renouveler leur carte professionnelle vtc</strong>, les
            chauffeurs doivent fournir une attestation de suivi de la
            <strong>formation continue</strong>. Cette attestation est délivrée
            par un organisme de <strong>formation agréé</strong>. Il est
            recommandé aux chauffeurs de planifier leur formation à l'avance et
            de s'inscrire auprès d'un <strong>centre de formation agréé</strong>
            pour garantir la validité de leur
            <strong>carte professionnelle vtc</strong>.
          </p>

          <p>
            <strong
              >Renouveler sa carte professionnelle de chauffeur VTC</strong
            >
            est essentiel pour pouvoir continuer à exercer légalement l'activité
            de transport de personnes. Cela permet de garantir que les
            <strong>chauffeurs VTC</strong> sont formés aux normes et aux
            exigences en vigueur, assurant ainsi la sécurité et la satisfaction
            des clients. De plus, en maintenant leurs compétences à jour, les
            <strong>chauffeurs VTC</strong> peuvent offrir un service de
            qualité, adapté aux besoins et aux attentes des passagers.
          </p>
        </div>
      </article>
    </template>
  </FormationDetailLayout>
</template>

<script>
import FormationDetailLayout from "@/components/formations/FormationDetailLayout.vue";
import { useMeta } from "vue-meta";

const heroImage = require("@/assets/pictures/formation-vtc-continue.webp");
const heroStats = [
  { label: "Prix", value: "170€" },
  { label: "Durée", value: "14h / 2 jours" },
];

export default {
  name: "VtcContinue",
  components: { FormationDetailLayout },
  setup() {
    useMeta({
      title: "Formation continue VTC",
      description: [
        {
          content:
            "Suivez notre formation continue VTC pour rester à jour sur la réglementation en vigueur, les nouvelles tendances du secteur, les techniques de service client avancées et bien plus encore. Améliorez vos compétences en tant que chauffeur VTC expérimenté.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.institut-taxi.fr/formation-vtc-continue",
        },
      ],
    });
  },
  data() {
    return {
      heroImage,
      heroStats,
    };
  },
};
</script>
